<template>
  <div
    class="service-visit-filter-fields"
    :class="{ 'service-visit-filter-fields--stacked': stacked }"
  >
    <b-col class="pb-0" md="4" lg="3">
      <b-form-group label-for="service-visit-date-from-filter">
        <FormDatepicker
          id="service-visit-date-from-filter"
          :value="filters.dateFrom"
          :i18n="{ placeholder: 'FORM_LABELS.DATE_FROM' }"
          :validateState="{}"
          @input="$emit('update-filter', 'dateFrom', $event)"
        />
      </b-form-group>
    </b-col>

    <b-col class="pb-0" md="4" lg="3">
      <b-form-group label-for="service-visit-date-to-filter">
        <FormDatepicker
          id="service-visit-date-to-filter"
          :value="filters.dateTo"
          :i18n="{ placeholder: 'FORM_LABELS.DATE_TO' }"
          :validateState="{}"
          @input="$emit('update-filter', 'dateTo', $event)"
        />
      </b-form-group>
    </b-col>

    <b-col class="pb-0" md="4" lg="3">
      <b-form-group label-for="service-visit-location-filter">
        <FormSelect
          id="service-visit-location-filter"
          :value="filters.serviceLocationIds"
          :options="serviceLocations"
          :placeholder="$t('FORM_LABELS.SERVICE_LOCATION')"
          :clearable="true"
          :multiple="true"
          @input="$emit('update-filter', 'serviceLocationIds', $event)"
        />
      </b-form-group>
    </b-col>

    <b-col v-if="showMechanic" class="pb-0" md="4" lg="3">
      <b-form-group label-for="service-visit-mechanic-filter">
        <FormSelect
          id="service-visit-mechanic-filter"
          :value="filters.mechanicIds"
          :options="mechanics"
          :placeholder="$t('MENU.ITEM.SERVICE.MECHANICS')"
          :clearable="true"
          :multiple="true"
          @input="$emit('update-filter', 'mechanicIds', $event)"
        />
      </b-form-group>
    </b-col>

    <b-col v-if="showPriority" class="pb-0" md="4" lg="3">
      <b-form-group label-for="service-visit-priority-filter">
        <FormSelect
          id="service-visit-priority-filter"
          :value="filters.priorityIds"
          :options="priorities"
          :placeholder="$t('FORM_LABELS.PRIORITY')"
          :clearable="true"
          :multiple="true"
          @input="$emit('update-filter', 'priorityIds', $event)"
        />
      </b-form-group>
    </b-col>

    <b-col v-if="showStatus" class="pb-0" md="4" lg="3">
      <b-form-group label-for="service-visit-status-filter">
        <FormSelect
          id="service-visit-status-filter"
          :value="filters.statusIds"
          :options="statuses"
          :placeholder="$t('FORM_LABELS.STATUS')"
          :clearable="true"
          :multiple="true"
          @input="$emit('update-filter', 'statusIds', $event)"
        />
      </b-form-group>
    </b-col>
  </div>
</template>

<script>
import FormDatepicker from "@/view/content/forms/components/FormDatepicker.vue";
import FormSelect from "@/view/content/forms/components/FormSelect.vue";

export default {
  name: "ServiceVisitFilterFields",
  components: {
    FormDatepicker,
    FormSelect
  },
  props: {
    filters: {
      type: Object,
      required: true
    },
    mechanics: {
      type: Array,
      default: () => []
    },
    priorities: {
      type: Array,
      default: () => []
    },
    serviceLocations: {
      type: Array,
      default: () => []
    },
    statuses: {
      type: Array,
      default: () => []
    },
    showMechanic: {
      type: Boolean,
      default: true
    },
    showPriority: {
      type: Boolean,
      default: true
    },
    showStatus: {
      type: Boolean,
      default: true
    },
    stacked: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.service-visit-filter-fields {
  display: contents;
}

.service-visit-filter-fields--stacked {
  display: block;
}
</style>
